import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import _ from 'lodash';
import type { useGetControlsBasic } from 'src/hooks/queries/control/useGetControlsBasic';

import { getFriendlyId } from '@/utils/friendlyId';

type GetControlsBasicData = NonNullable<
  ReturnType<typeof useGetControlsBasic>['data']
>;

export const getOptions = (
  allControls: GetControlsBasicData | undefined,
  defaultValues: { value: string }[]
): { value: string; label: string; tags: string[] }[] => {
  const ids = defaultValues.map((d) => d.value);
  const controlsById = _.keyBy(allControls?.control, 'Id');

  let options: {
    Id: string;
    Title?: string;
    SequentialId?: null | number | undefined;
  }[] = allControls?.control ?? [];

  options = options.concat(
    (allControls?.node ?? []).filter(
      (n) => ids.includes(n.Id) && !controlsById[n.Id]
    )
  );

  return (
    options?.map((o) => ({
      value: o.Id,
      tags: o.Title
        ? [getFriendlyId(Parent_Type_Enum.Control, o.SequentialId)]
        : [],
      label: o.Title ?? getFriendlyId(Parent_Type_Enum.Control, o.SequentialId),
    })) ?? []
  );
};
